export default "__VITE_ASSET__Vq3PQABy__"